import Vue from "vue";
import VueRouter from "vue-router";
import Landing from "../views/Landing.vue";
import Recent from "../views/Recent.vue";
import About from "../views/About.vue";
import Translate from "../views/Translate.vue";
import Disclaimer from "../views/Disclaimer.vue";
import Privacy from "../views/Privacy.vue";
import Terms from "../views/Terms.vue";
import Contact from "../views/Contact.vue";
// import firebase from "firebase";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Landing",
    component: Landing
  },
  {
    path: "/about",
    name: "About",
    component: About
  },
  {
    path: "/recent",
    name: "Recent",
    component: Recent,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/translate",
    name: "Translate",
    component: Translate
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: Privacy
  },
  {
    path: "/disclaimer",
    name: "Disclaimer",
    component: Disclaimer
  },
  {
    path: "/terms",
    name: "Terms",
    component: Terms
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// router.beforeResolve((to, from, next) => {
//   let user = firebase.auth();
//   console.log(user);
//   if (to.name === "Recent" && user.currentUser === null) {
//     next("/");
//   } else {
//     next();
//   }
// });

export default router;
